import { render, staticRenderFns } from "./MyAccountDetails.vue?vue&type=template&id=b6353f30&"
import script from "./MyAccountDetails.vue?vue&type=script&lang=js&"
export * from "./MyAccountDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports